var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.expedition !== null && _vm.accessGranted)?_c('div',[_c('ExpeditionForm',{attrs:{"loading":_vm.loading,"errorsData":_vm.errorsData},on:{"validate":_vm.createExpedition,"cancel":_vm.cancel},model:{value:(_vm.expedition),callback:function ($$v) {_vm.expedition=$$v},expression:"expedition"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }